// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2VH1p","profilesList":"_1qNS-","profile":"bMtik","title":"_23VYG","text":"_18McC"};